import React from 'react'
import { NoOpeartionText, NooperationContainer } from './styles'

export const NoOperations = () => {
    return (


        <NooperationContainer>

            <NoOpeartionText>NOTHING HERE !</NoOpeartionText>

        </NooperationContainer>


    )
}
